import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Swedish namespaces
import svCommon from './locales/sv/common.json';
import svBooking from './locales/sv/booking.json';
import svAuth from './locales/sv/auth.json';
import svAdmin from './locales/sv/admin.json';
import svCommunity from './locales/sv/community.json';
import svProfile from './locales/sv/profile.json';
import svActivities from './locales/sv/activities.json';
import svPayments from './locales/sv/payments.json';
import svErrors from './locales/sv/errors.json';
import svNotifications from './locales/sv/notifications.json';
import svCalendar from './locales/sv/calendar.json';
import svOpenMatch from './locales/sv/openMatch.json';
import svCoach from './locales/sv/coach.json';

// English namespaces
import enCommon from './locales/en/common.json';
import enBooking from './locales/en/booking.json';
import enAuth from './locales/en/auth.json';
import enAdmin from './locales/en/admin.json';
import enCommunity from './locales/en/community.json';
import enProfile from './locales/en/profile.json';
import enActivities from './locales/en/activities.json';
import enPayments from './locales/en/payments.json';
import enErrors from './locales/en/errors.json';
import enNotifications from './locales/en/notifications.json';
import enCalendar from './locales/en/calendar.json';
import enOpenMatch from './locales/en/openMatch.json';
import enCoach from './locales/en/coach.json';

export const defaultNS = 'common';
export const namespaces = [
  'common',
  'booking',
  'auth',
  'admin',
  'community',
  'profile',
  'activities',
  'payments',
  'errors',
  'notifications',
  'calendar',
  'openMatch',
  'coach',
] as const;

export const resources = {
  sv: {
    common: svCommon,
    booking: svBooking,
    auth: svAuth,
    admin: svAdmin,
    community: svCommunity,
    profile: svProfile,
    activities: svActivities,
    payments: svPayments,
    errors: svErrors,
    notifications: svNotifications,
    calendar: svCalendar,
    openMatch: svOpenMatch,
    coach: svCoach,
  },
  en: {
    common: enCommon,
    booking: enBooking,
    auth: enAuth,
    admin: enAdmin,
    community: enCommunity,
    profile: enProfile,
    activities: enActivities,
    payments: enPayments,
    errors: enErrors,
    notifications: enNotifications,
    calendar: enCalendar,
    openMatch: enOpenMatch,
    coach: enCoach,
  },
} as const;

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'sv',
    defaultNS,
    ns: [...namespaces],
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'i18nextLng',
      caches: ['localStorage'],
    },
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
